(function(){
  'use strict';

  function finiteNumber(input){
    var value=Number.parseFloat(input.value);
    return Number.isFinite(value)?value:0;
  }

  function clamp(value,min,max){
    return Math.min(Math.max(value,min),max);
  }

  function formatHours(value){
    return new Intl.NumberFormat('en-GB',{maximumFractionDigits:1}).format(value)+' hours';
  }

  function formatMoney(value){
    return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2}).format(value);
  }

  function placeToolkit(root){
    root.hidden=false;
    root.removeAttribute('hidden');
  }

  function initCalculator(root){
    if(root.getAttribute('data-nr-toolkit-ready')==='true')return;
    root.setAttribute('data-nr-toolkit-ready','true');
    placeToolkit(root);

    var form=root.querySelector('[data-nr-calculator]');
    var results=root.querySelector('[data-nr-results]');
    var timeOutput=root.querySelector('[data-nr-time]');
    var valueOutput=root.querySelector('[data-nr-value]');
    var announcement=root.querySelector('[data-nr-announcement]');
    if(!form||!results||!timeOutput||!valueOutput)return;

    form.addEventListener('submit',function(event){
      event.preventDefault();
      if(!form.reportValidity())return;
      var weeklyHours=clamp(finiteNumber(form.querySelector('[data-nr-weekly-hours]')),0,80);
      var minutesPerHour=clamp(finiteNumber(form.querySelector('[data-nr-minutes]')),0,240);
      var hourlyRate=clamp(finiteNumber(form.querySelector('[data-nr-rate]')),0,1000);
      var manualHours=weeklyHours*(minutesPerHour/60);
      var weeklyValue=manualHours*hourlyRate;
      timeOutput.textContent=formatHours(manualHours);
      valueOutput.textContent=formatMoney(weeklyValue);
      results.hidden=false;
      if(announcement)announcement.textContent='Estimate calculated: '+formatHours(manualHours)+' and '+formatMoney(weeklyValue)+' each week.';
      results.focus({preventScroll:true});
    });

    form.addEventListener('reset',function(){
      window.setTimeout(function(){
        results.hidden=true;
        timeOutput.textContent='0 hours';
        valueOutput.textContent='£0.00';
        if(announcement)announcement.textContent='Calculator reset.';
      },0);
    });
  }

  function initAll(context){
    var scope=context&&context.querySelectorAll?context:document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-nr-toolkit]'),initCalculator);
    if(scope.matches&&scope.matches('[data-nr-toolkit]'))initCalculator(scope);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});
  }else{
    initAll(document);
  }
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();
